angular.module('admin')
  .controller('OfficesCtrl', ['$scope', '$state','OfficeService','BrokerageService','AccountService', 'HelperService', 'UtilService', 'FEATURES'
    , function($scope, $state, OfficeService, BrokerageService, AccountService, helpers, utils, FEATURES){

      $scope.accountService = AccountService;

      var params = {};

      if($scope.accountService.hasFeature(FEATURES.ADMIN))
        params = {filter:{include:'offices', order: 'name ASC'}};

      $scope.refreshBrokerages = function(){
        BrokerageService.getAll(params)
          .then(function(data){
            $scope.brokerages = data;
          }).catch(function(err){
            utils.trackException('Get all offices error', err);
          });
      };

      $scope.showAddOffice = function(brokerage){
        $scope.addOfficeBrokerage = brokerage;
        $scope.currentModal = 'addOffice';
      };

      $scope.showEditOffice = function(office){
        $scope.editOffice = office;
        $scope.currentModal = 'editOffice';
      };

      $scope.showEditBrokerage = function(brokerage){
        $scope.editBrokerage = brokerage;
        $scope.currentModal = 'editBrokerage';
      };

      $scope.closeModal = function(){
        $scope.currentModal = false;
        $scope.editBrokerage = null;
        $scope.editOffice = null;
        $scope.refreshBrokerages();
      };

      $scope.refreshBrokerages();
  }]);
